module.exports = __webpack_public_path__ + "img/svg/generic-banner.5812fcd9f245a1f5c59a8d086c411de3.svg";